import script from "./selectPerson.vue?vue&type=script&setup=true&name=SelectPerson&lang=js"
export * from "./selectPerson.vue?vue&type=script&setup=true&name=SelectPerson&lang=js"

import "./selectPerson.vue?vue&type=style&index=0&id=2b31e445&scoped=true&lang=css"
import "./selectPerson.vue?vue&type=style&index=1&id=2b31e445&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b31e445"]])

export default __exports__